import React from 'react'
// import { Menu } from 'antd';
export default class NavBarCompoents extends React.Component {
    render() {

        return (
            <div className="logo" style={{ color: '#fff' }}>
                <h3 style={{ color: '#fff' }}>明道普霖斯頓雙語小學入學填報系統</h3>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/dashboards_redux/components/DefaultDashboardTemplate/NavBarCompoents.jsx